/* Copyright (C) 2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
// 2. Store and Types. 
// 3. Scripts. 
// 4. Components and Views. 
// 04/01/2022 Paul.  Add Pacific theme, derived from Arctic.
import PacificHeaderButtons           from './Pacific/HeaderButtons'          ;
import ArcticHeaderButtons            from './Arctic/HeaderButtons'           ;
import AtlanticHeaderButtons          from './Atlantic/HeaderButtons'         ;
import SevenHeaderButtons             from './Seven/HeaderButtons'            ;
import SixHeaderButtons               from './Six/HeaderButtons'              ;
import SugarHeaderButtons             from './Sugar/HeaderButtons'            ;
import Sugar2006HeaderButtons         from './Sugar2006/HeaderButtons'        ;

export default function HeaderButtonsFactory(sTHEME: string)
{
	let ctl: any = null;
	switch ( sTHEME )
	{
		// 04/01/2022 Paul.  Add Pacific theme, derived from Arctic.
		case 'Pacific'  :  ctl = PacificHeaderButtons  ;  break;
		case 'Arctic'   :  ctl = ArcticHeaderButtons   ;  break;
		case 'Atlantic' :  ctl = AtlanticHeaderButtons ;  break;
		case 'Mobile'   :  ctl = null                  ;  break;
		case 'Seven'    :  ctl = SevenHeaderButtons    ;  break;
		case 'Six'      :  ctl = SixHeaderButtons      ;  break;
		case 'Sugar'    :  ctl = SugarHeaderButtons    ;  break;
		case 'Sugar2006':  ctl = Sugar2006HeaderButtons;  break;
	}
	if ( ctl )
	{
		//console.log((new Date()).toISOString() + ' ' + 'HeaderButtonsFactory found ' + sTHEME);
	}
	else
	{
		// 04/01/2022 Paul.  Add Pacific theme, derived from Arctic.
		ctl = PacificHeaderButtons;
		//console.log((new Date()).toISOString() + ' ' + 'HeaderButtonsFactory not found ' + sTHEME + ', using Arctic');
	}
	return ctl;
}

